function isHomeOrEnd(key: string) {
	return key === "Home" || key === "End";
}

export function isNavigationKey(key: string) {
	return isHomeOrEnd(key) || key.startsWith("Arrow") || key.startsWith("Page") || key === " ";
}
